import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem, ConfirmationService } from 'primeng/api';
import * as _ from 'underscore';
import { LazyLoadEvent } from 'primeng/api';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from 'src/app/shared/services/services.service';
import { environment } from 'src/environments/environment';
import { ITabs } from '@devinforius/i-navigation';
import { Cols } from 'src/app/shared/models';
@Component({
  selector: 'app-super-list-simple',
  templateUrl: './super-list-simple.component.html',
  styleUrls: ['./super-list-simple.component.scss'],
})
export class SuperListSimpleECourrierComponent {
  public lists = [];
  @Input() set items(value) {
    this.virtualItems = [];
    this.totalRecords = 0;

    if (value.length > 0) {
      value.map((x) => {
        if (x.adressePrincipale) {
          x.adresse = x.adressePrincipale
            ? (x.adressePrincipale?.impression_Adresse ? x.adressePrincipale?.impression_Adresse + ' ' : '') +
              (x.adressePrincipale?.impression_CodePostal ? x.adressePrincipale?.impression_CodePostal + ' ' : '') +
              (x.adressePrincipale?.impression_Localite ? x.adressePrincipale?.impression_Localite : '')
            : '';
        }
      });
      this.virtualItems = _.sortBy(value, 'label');
      this.totalRecords = value.length;
      this.rowsToShow = 100;
    }
  }
  @Input() columns: Cols[];
  @Input() boolShowHeader?: boolean;
  @Input() typeContact;
  @Input() boolMultiSelect?: boolean;
  @Input() destinataire?: boolean;
  @Input() alignLast?: string;
  @Input() boolImageMode?: boolean;
  @Input() text?: string;
  @Input() height?: string = '520px';
  @Input() icon?: string;
  @Input() iconColor?: string;
  @Input() deletable: boolean;
  @Input() showGroup: boolean;
  @Output() multiSelectValue = new EventEmitter();
  @Output() selectedValue = new EventEmitter();
  public activeOptionsID: number;
  public status: SelectItem[];
  public totalRecords: number;
  public selectAll = false;
  public selected = [];
  public loading: boolean;
  activeLine = 0;
  boolShowAction = false;
  public virtualItems = [];
  public searchTypeContact = '';
  public searchString = '';
  public typeGroupSearch: boolean;
  public typeGroup = [
    { label: 'Filtrer par groupe', value: 'oui' },
    { label: 'Filtrer par service', value: 'non' },
  ];
  public rowsToShow = 100;
  public date = Date.now();
  public apiBaseUrl: string = null;
  public activeStates: ITabs[] = [
    { header: 'Tous', id: 'all', active: false },
    { header: 'Actifs', id: 'true', active: true },
    { header: 'Inactifs', id: 'false', active: false },
  ];
  public activeStateRecipient: boolean | string = true;
  @Input() isAllowedToFilterByStateActive; //va permettre d'afficher le tri par select-button
  @Input() isAllowedToFilterByStateActiveCustom; //va permettre d'afficher le tri par select-button
  @Input() typeOfContact;
  @Input() set servicesList(value) {
    this.listServices = value;
  } //va permettre d'afficher le tri par select-button
  public listFiltered = [];
  public listServices = [];
  constructor(
    private confirmationService: ConfirmationService,
    public http: HttpClient,
    public route: ActivatedRoute,
    public servicesService: ServicesService
  ) {
    const config = environment;
    this.apiBaseUrl = config.apiICourrierBaseUrl;
  }

  toggleLine(arg) {
    if (arg.id) {
      this.activeLine = arg.id;
    }
  }

  fct(item) {
    this.selectedValue.emit({ item });
  }

  selectItem(event, item) {
    item.checked = event.currentTarget.checked;
    this.emit();

    // this.multiSelectValue.emit({ checkedValue: event.currentTarget.checked, item });
  }

  selectAllItems() {
    this.selectAll = !this.selectAll;
    this.virtualItems = this.virtualItems.map((item) => {
      item.checked = this.selectAll;
      return item;
    });
    this.emit();
  }

  emit() {
    this.selected = this.virtualItems.filter((x) => x.checked === true);
    this.multiSelectValue.emit(this.selected);
  }

  layLoadData(event: LazyLoadEvent) {
    this.loading = true;
    this.lists = [];

    // on check pour si y a un nom encoder dans la barre de recherche
    if (event.filters != undefined && event.filters['name'] != undefined) {
      this.lists = this.search(this.virtualItems, 'name', event.filters.name.value);
    }

    if (this.isAllowedToFilterByStateActive || this.isAllowedToFilterByStateActiveCustom) {
      // on check le filtre des actifs inactifs
      if (this.isAllowedToFilterByStateActive) {
        this.filterItems().then(() => {
          this.setListsDatas(event);
        });
      }
      if (this.isAllowedToFilterByStateActiveCustom) {
        this.filterCustomActive().then(() => {
          this.setListsDatas(event);
        });
      }
    } else this.setListsDatas(event);
  }

  private setListsDatas(event): void {
    console.log('??');
    if (event && _.isString(event.sortField) && _.isNumber(event.sortOrder)) {
      this.virtualItems = _.sortBy(this.listFiltered, event.sortField);
      if (event.sortOrder === -1) this.listFiltered.reverse();
    }
    if (this.listFiltered.length === 0) {
      //on peut ne pas passer dans les filtres (genre pour services et groupes) => faut le remplir :D
      this.listFiltered = this.virtualItems;
    }
    const arrayTemp = this.listFiltered.slice(event.first, event.first + event.rows);
    this.lists = _.sortBy(arrayTemp, (i) => i.name.toLowerCase());
    this.loading = false;
  }

  public search(array, key, search, active = true) {
    if (active) {
      if (_.isString(search) && (search.length == 0 || !search || search == null)) return array;

      if (!key || !search) {
        throw 'Il faut une key => searchByKey:key:value';
      }

      if (array?.length > 0) {
        const txt = String(search).toLowerCase().replace(/\s/g, '');
        if (txt.length > 0) {
          const filtered = [];
          array.forEach((item) => {
            const value = item[key];
            if (typeof value == 'string') {
              const val = String(value).toLowerCase().replace(/\s/g, '');
              const test = val.search(txt) >= 0;

              if (test) {
                filtered.push(item);
              }
            }
          });

          this.loading = false;
          return filtered;
        } else return array;
      }
    } else return array;
  }

  public filter(key1, value1, key2, value2) {
    return new Promise((resolve) => {
      this.loading = true;
      this.listFiltered = [];
      this.lists = [];
      let toPush = [];
      if (value1 === '' && value2 === 'all') {
        toPush = this.virtualItems;
      } else {
        this.virtualItems.map((x) => {
          x.userActive = this.typeOfContact === 'user' ? x.active : !x.nePlusUtiliser;
          if (value1 === '') {
            if (x[key2] === value2) {
              x.label = x.name.trimStart();
              toPush.push(x);
            }
          } else if (value2 === 'all') {
            if (x[key1] === value1) {
              x.label = x.name.trimStart();
              toPush.push(x);
            }
          } else {
            if (x[key1] === value1 && x[key2] === value2) {
              x.label = x.name.trimStart();
              toPush.push(x);
            }
          }
        });
      }
      toPush = _.sortBy(toPush, 'name');

      setTimeout(() => {
        const startTo = 0;

        const length = toPush.length;
        const chunk = [];
        for (let i = 0; i < length; i++) {
          const item = toPush[startTo + i];
          if (_.isObject(item)) chunk.push(item);
        }
        this.listFiltered = _.uniq(chunk, 'id');
        this.listFiltered = _.sortBy(this.listFiltered, 'name');
        this.lists = this.listFiltered;
        this.totalRecords = toPush.length;
        this.loading = false;
        resolve(true);
      }, 1000);
    });
  }

  getAvatar(url) {
    this.http.get(url).subscribe({
      next: (res) => {
        return res;
      },
    });
  }
  filterItems(event?: 'all' | 'true' | 'false') {
    return new Promise((resolve) => {
      if (event) {
        event === 'all' ? (this.activeStateRecipient = 'all') : (this.activeStateRecipient = Boolean(event));
      }
      this.lists = [];
      this.filter('typeContactID', this.searchTypeContact, 'userActive', this.activeStateRecipient).then(() => {
        resolve(true);
      });
    });
  }
  filterCustomActive(event?: 'all' | 'true' | 'false') {
    return new Promise((resolve) => {
      this.loading = true;
      this.lists = [];
      let temp = [];
      temp = this.virtualItems;
      if (event) {
        if (event !== 'all') {
          this.listFiltered = temp.filter((x) => x.active === Boolean(event) || x.userActive === Boolean(event));
          this.lists = this.listFiltered;
          const firstItem = {
            item: this.listFiltered[0],
          };
          this.selectedValue.emit(firstItem);
          this.loading = false;
          resolve(true);
        } else {
          this.listFiltered = temp;
          this.lists = this.listFiltered;
          const firstItem = {
            item: this.listFiltered[0],
          };
          this.selectedValue.emit(firstItem);
          this.loading = false;
          resolve(true);
        }
      } else {
        this.listFiltered = temp.filter((x) => x.active === this.activeStateRecipient || x.userActive === this.activeStateRecipient);
        this.lists = this.listFiltered;
        const userId = this.route.snapshot.params.id;

        let itemChosen;

        if (userId) {
          //* Si on a un id, on va vérifier que l'utilisateur en route params existe, pour le garder à droite
          //* S'il existe pas on renvoie le premier
          const itemIndex = this.listFiltered.map((x) => x.id).indexOf(+userId);
          if (itemIndex > -1) {
            itemChosen = {
              item: this.listFiltered[itemIndex],
            };
          } else {
            itemChosen = {
              item: this.listFiltered[0],
            };
          }
        } else {
          //* S'il y a pas d'id on renvoie le premier
          itemChosen = {
            item: this.listFiltered[0],
          };
        }
        this.selectedValue.emit(itemChosen);
        this.loading = false;
        resolve(true);
      }
    });
  }

  filterByService(event) {
    this.servicesService.fetchServiceUsersIds(event.node.value).subscribe({
      next: (ids: number[]) => {
        const toPush = _.sortBy([...this.virtualItems.filter((item) => ids.includes(item.id))], 'name');
        setTimeout(() => {
          const startTo = 0;
          // const length =  50
          const length = toPush.length;
          const chunk = [];

          for (let i = 0; i < length; i++) {
            const item = toPush[startTo + i];

            if (_.isObject(item)) chunk.push(item);
          }

          this.listFiltered = _.uniq(chunk, 'id');
          this.listFiltered = _.sortBy(this.listFiltered, 'name');
          this.lists = this.listFiltered;
          this.totalRecords = toPush.length;
          this.loading = false;
        }, 1000);
      },
      error: (err: HttpErrorResponse) => {
        console.error(err);
      },
    });
  }

  /**
   * Filter the list of items based on a search string.
   * @param search type string
   */
  searchList(search: string) {
    const listSearch = [];
    if (search.length >= 2) {
      const words = search.split(' ');
      this.listFiltered.filter((item) => {
        if (this.typeOfContact === 'contact' && item.adresse) {
          return words.every(
            (word) => item.name.toLowerCase().includes(word.toLowerCase()) || item?.adresse.toLowerCase().includes(word.toLowerCase())
          )
            ? listSearch.push(item)
            : null;
        } else {
          return words.every((word) => item.name.toLowerCase().includes(word.toLowerCase())) ? listSearch.push(item) : null;
        }
      });
      this.lists = listSearch;
    } else if (search.length < 1) {
      this.lists = this.virtualItems;
    }
  }
}
